/** Keep saved selections visible without changing their values or treating partial data as absence. */
export function retainLocalSelections(available: readonly string[], selected: readonly string[]): string[] {
  return [...new Set([...available, ...selected])];
}

export function localMemberLabel(
  value: string,
  available: readonly string[],
  complete: boolean,
  label = value,
): string {
  return complete && !available.includes(value) ? `${label} (no data with current filters)` : label;
}
